export const MARKET_ROUND_STATES = {
  waiting_for_all_players: 'waiting_for_all_players',
  started: 'started',
  finished: 'finished'
}
export const SEGMENT_ROUND_STATES = {
  waiting_for_all_players: 'waiting_first_move',
  started: 'started',
  finished: 'finished'
}
export const SEGMENT_ROUND_TEAM_STATES = {
  pending_move: 'pending_move',
  finish: 'finish'
}
export const MARKET_ROUND_PLAYER_STATES = {
  waiting: 'waiting',
  playing: 'playing'
}
